<template>
  <div class="filter-card-wrapper">
    <div
      class="filter-card__wrapper__header"
      @click="onCardToggle"
    >
      <div class="rich-text">
        <p><strong>{{ title }}</strong></p>
      </div>
      <slot name="radiowrapper"></slot>
      <Icon
        v-if="!hasRadio"
        :name="expanded ? 'chevron-up' : 'chevron-down'"
        class="filter-card-wrapper__header--chevron_icon"
        size="24"
      ></Icon>
    </div>
    <div
      v-if="expanded"
      class="filter-card-wrapper__body"
    >
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
// Common components
import { Icon } from "../../components";

export default {
  name: "FilterCardWrapper",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * Name of the filter
    */
    title: { type: String, required: true },
    /**
     * @description
     * When hasRadio flag is true then title card will have radio button next to the title
    */
    hasRadio: { type: Boolean, default: false },
    /**
     * @description
     * When expaneded flag is true, filter content will be shown
    */
    expanded: { type: Boolean, default: false },
  },
  methods: {
    /**
     * @description
     * Calls onCardToggle method defined on the parent(FilterBar)component with filter name as param
     * @param {string} item - Selected column
    */
    onCardToggle () {
      this.$parent.$listeners.onCardToggle(this.title);
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-card-wrapper {
  background-color: var(--Gray-50);
  margin: 8px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  & .filter-card-wrapper__header {
    display: flex;
    flex: 1;
    justify-content: space-between;
    cursor: pointer;
    & .rich-text > p {
      color: var(--Blue-900-Darkest);
    }
    & .filter-card-wrapper__header--chevron_icon {
      color: var(--Blue-900-Darkest);
    }
  }
}
</style>
